import InactiveAccountLock from './InactiveAccountLock';
export default InactiveAccountLock;
